import { Card, Flex } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { QuestionNode } from "./QuestionNode";
import * as styles from "./styles_vanilla.css";
import type { TreeSection } from "./buildTree";

export type SectionNodeProps = {
  section: TreeSection;
  arenaId: number;
  ddqId: string;
};

export const SectionNode = ({ section, arenaId, ddqId }: SectionNodeProps) => {
  return (
    <Card
      title={`${section.number}. ${section.title}`}
      isFullWidth
      className={styles.section}
      data-testid={`ddq-section-${section.id}`}
    >
      {section.questions.length > 0 && (
        <Flex flexDirection="column" gap={SPACING.SMALL} className={styles.questionList}>
          {section.questions.map((question) => (
            <QuestionNode
              key={question.id}
              question={question}
              arenaId={arenaId}
              ddqId={ddqId}
            />
          ))}
        </Flex>
      )}
      {section.subsections.length > 0 && (
        <Flex flexDirection="column" className={styles.subsectionList}>
          {section.subsections.map((subsection) => (
            <SectionNode
              key={subsection.id}
              section={subsection}
              arenaId={arenaId}
              ddqId={ddqId}
            />
          ))}
        </Flex>
      )}
    </Card>
  );
};
